export default async function updateRule({ commit, rootGetters, dispatch }, { ruleId, ruleData }) {
    try {
        commit('SET_UPDATE_RULE_LOADING', true);

        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];

        let customer_id = customer.customer_id;
        if (customer_id === 0) {
            customer_id = selected_customer.customer_id;
        }

        const data = {
            ...ruleData,
            customer_id,
            id: ruleId
        };

        const response = await window.axios.put('/proxy/ai/classification-rules', data);

        if (response.data.success) {
            dispatch('notifications/pushNotification', 'Classification rule updated successfully', { root: true });

            commit('SET_RULE', response.data.data);
        } else {
            dispatch('notifications/setError', 'Failed to update classification rule', { root: true });
        }
    } catch (error) {
        console.error('Error updating classification rule:', error);
        dispatch('notifications/setError', 'Failed to update classification rule', { root: true });
    } finally {
        commit('SET_UPDATE_RULE_LOADING', false);
    }
}